import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Button } from 'antd';
import { cloneDeep, uniqBy } from 'lodash';
import style from '../styles/copyComponent.scss';
import MultiSelect from '../../../../components/MultiSelect';

const CopyComponent = ({
  combinations,
  selectedCombinationId,
  typology,
  handleCopyRI,
  isSaved
}) => {
  const [isChecked, setChecked] = useState(false);
  const [selectedDropDown, setSelectedDropDown] = useState([]);
  const [copiedList, setCopiedList] = useState([]);

  const handleChange = (value) => {
    setSelectedDropDown(value);
  };

  const dropDownOptions = useMemo(() => {
    let options = [];
    combinations.map((option, index) => {
      index++;
      if (selectedCombinationId !== option?.id) {
        let label = `Set - ${option?.title}`;
        options.push({ title: label, value: option?.id });
      }
    });

    return options;
  }, [combinations, selectedCombinationId]);

  const copyRiskIndicator = () => {
    let cpList = cloneDeep(copiedList);
    cpList.push(
      ...dropDownOptions?.filter((option) =>
        selectedDropDown.includes(option?.value)
      )
    );

    setCopiedList(uniqBy(cpList, 'title'));
    handleCopyRI(typology?.id, selectedCombinationId, selectedDropDown);
    setSelectedDropDown([]);
  };

  useEffect(() => {
    setSelectedDropDown([]);
    setChecked(false);
    setCopiedList([]);
  }, [selectedCombinationId]);

  const getCurrentlyCopied = useMemo(() => {
    if (!copiedList?.length) return <></>;

    return (
      <>
        <p>Currently copied to:</p>
        <div className={style.copyInfo}>
          {copiedList?.map(({ title }) => {
            return <p key={title}>{title}</p>;
          })}
        </div>
      </>
    );
  }, [copiedList, selectedCombinationId]);

  useMemo(() => {
    if (isSaved) {
      setCopiedList([]);
      setSelectedDropDown([]);
      setChecked(false);
    }
  }, [isSaved]);

  return (
    <div className={style.container}>
      <div className={style.copyInfoContainer}>{getCurrentlyCopied}</div>

      <div className={style.copythresHoldContainer}>
        <Checkbox
          onChange={(e) => setChecked(e.target.checked)}
          className={style.checkboxLabel}
          checked={isChecked}>
          Copy Threshold Values to Other Sets
        </Checkbox>
        <MultiSelect
          options={dropDownOptions}
          values={selectedDropDown}
          onChange={handleChange}
          isDisabled={!isChecked}
        />

        <div className={style.actionButton}>
          <Button
            type="primary"
            className={style.copyButton}
            disabled={!isChecked || !selectedDropDown?.length > 0}
            onClick={copyRiskIndicator}>
            Copy to
          </Button>
        </div>
      </div>
    </div>
  );
};

CopyComponent.propTypes = {
  combinations: PropTypes.array,
  typology: PropTypes.object,
  selectedCombinationId: PropTypes.number,
  handleCopyRI: PropTypes.func,
  isSaved: PropTypes.bool
};

export default CopyComponent;
